import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import getObjectsCases from "./cases/get-objects.cases";
import getObjectsLocationsCases from "./cases/get-objects-locations.cases";
import { ObjectsState } from "../entities/interfaces/object-state.interface";
import getObjectDataForMapCases from "./cases/get-object-data-for-map.cases";
import onObjectLocationReportedEventCases from "./cases/on-object-location-reported-event.cases";
import onObjectIconUpdatedEventCases from "./cases/on-object-icon-updated-event.cases";
import { types } from "@vilocnv/allsetra-core";
import getObjectsSearchCases from "./cases/get-objects-search.cases";
import { mapObjectsToMarkers } from "../entities/mappers/map-objects-to-markers.mapper";

const initialState: ObjectsState = {
  objects: [],
  isLoadingObjects: false,
  isLoadingObjectDetail: false,
  markers: [],
  objectFilters: {
    groups: [],
    objectTypes: [],
    keyId: []
  },
  selectedObject: undefined,
  objectsSearch: [],
  isLoadingObjectsSearch: false,
  objectStatusesByUniqueId: {},
  showInactiveObjects: false
};

const objectsSlice = createSlice({
  name: "objects/v2",
  initialState,
  reducers: {
    clearSelectedObject: (state) => {
      state.selectedObject = undefined;
    },
    setSelectedObject: (
      state,
      action: PayloadAction<{
        uniqueId: string;
        fallbackObject?: types.IObject;
      }>
    ) => {
      const { uniqueId, fallbackObject } = action.payload;
      const object =
        state.objects.find((o) => o.uniqueId === uniqueId) ?? fallbackObject;
      if (!object) {
        state.selectedObject = undefined;
        return;
      }

      const status = object.status ?? state.objectStatusesByUniqueId[uniqueId];

      state.selectedObject = {
        ...object,
        status: status as types.IObject["status"]
      };
    },
    setObjectFilters: (state, action: PayloadAction<types.IMapFilter>) => {
      state.objectFilters = action.payload;
    },
    setShowInactiveObjects: (state, action: PayloadAction<boolean>) => {
      state.showInactiveObjects = action.payload;
      state.markers = mapObjectsToMarkers(state.objects, {
        statusLookup: state.objectStatusesByUniqueId,
        showInactiveObjects: state.showInactiveObjects
      });
    }
  },
  extraReducers: (builder) => {
    getObjectsCases(builder);
    getObjectsLocationsCases(builder);
    getObjectDataForMapCases(builder);
    getObjectsSearchCases(builder);
    onObjectLocationReportedEventCases(builder);
    onObjectIconUpdatedEventCases(builder);
  }
});

export default objectsSlice.reducer;

export const {
  clearSelectedObject,
  setSelectedObject,
  setObjectFilters,
  setShowInactiveObjects
} = objectsSlice.actions;
